"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pick.title': 'Onboarding Dipendente',
    'onboarding.pick.description': 'A chi vuoi assegnare nuove responsabilità nella tua azienda?',
    'onboarding.pick.loading': 'Caricamento professioni...',
};
